var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndeterminateIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.14551 9C3.14551 5.68629 5.8318 3 9.14551 3H15.1455C18.4592 3 21.1455 5.68629 21.1455 9V15C21.1455 18.3137 18.4592 21 15.1455 21H9.14551C5.8318 21 3.14551 18.3137 3.14551 15V9Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 3C5.68629 3 3 5.68629 3 9V15C3 18.3137 5.68629 21 9 21H15C18.3137 21 21 18.3137 21 15V9C21 5.68629 18.3137 3 15 3H9ZM7.96484 11C7.41256 11 6.96484 11.4477 6.96484 12C6.96484 12.5523 7.41256 13 7.96484 13H16.0348C16.5871 13 17.0348 12.5523 17.0348 12C17.0348 11.4477 16.5871 11 16.0348 11H7.96484Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndeterminateIcon);
export { ForwardRef as ReactComponent };